// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapperCss_w1e7jq8x{background:var(--gray00);}
`, "",{"version":3,"sources":["webpack://./node_modules/@fs/zion-ui/dist/es/info-sheet/InfoSheetFooter.css"],"names":[],"mappings":"AAAA,qBAAqB,wBAAwB,CAAC","sourcesContent":[".wrapperCss_w1e7jq8x{background:var(--gray00);}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
